/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Method_CashInputs */

const en_my_payments_method_cash = /** @type {(inputs: My_Payments_Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cash`)
};

const pl_my_payments_method_cash = /** @type {(inputs: My_Payments_Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gotówka`)
};

/**
* | output |
* | --- |
* | "cash" |
*
* @param {My_Payments_Method_CashInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_method_cash = /** @type {((inputs?: My_Payments_Method_CashInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Method_CashInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_method_cash(inputs)
	return en_my_payments_method_cash(inputs)
});